module.exports = __webpack_public_path__ + "img/stories.d1147dd5.png";